import React, { useCallback } from 'react'

import { Tooltip } from 'antd'

import { getMessage } from '../../../../../../../util/IntlMessages'
import { evaluateRequired } from '../helpers/requiredRule'

import './PanelHeader.less'

export function PanelHeader({ groupName, fields, formValues, fieldsById }) {
  const hasRequiredField = useCallback(
    () => fields.some((field) => evaluateRequired(field, formValues, fieldsById)),
    [fields, formValues, fieldsById]
  )

  return (
    <span className="PanelHeader__groupCollapseHeader">
      {groupName}
      {hasRequiredField() && (
        <Tooltip title={getMessage('groupHasMandatoryField')}>
          <span className="PanelHeader__groupCollapseRequired">{' *'}</span>
        </Tooltip>
      )}
    </span>
  )
}
